<template>
  <div class="permissionData-container">
    <div class="permissionData-card">
      <div class="permissionData-barChart-header">
        <div class="font-format-big">{{ permissionData.text }}</div>
        <div class="permissionData-date-select">
          <span
            v-for="item in permissionData.engine"
            :key="item.tag"
            class="permissionData-date-select-item"
            :class="{
              'permissionData-date-select-active': barData.tag === item.tag
            }"
            @click="changeTab(item)"
            >{{ item.name }}</span
          >
        </div>
        <!-- <div>查看详情</div> -->
      </div>
      <div class="permissionData-main">
        <div class="permissionData-useInfo">
          <div class="permissionData-useInfo-item">
            <div class="permissionData-useInfo-item-title">总用量：</div>
            <div class="permissionData-useInfo-item-value">
              {{ permissionData.total || 0 }}
            </div>
          </div>
          <div class="permissionData-useInfo-item">
            <div class="permissionData-useInfo-item-title">
              当前引擎总用量：
            </div>
            <div class="permissionData-useInfo-item-value">
              {{ barData.total || 0 }}
            </div>
          </div>
        </div>
        <div class="permissionData-info">
          <div class="permissionData-left">
            <div ref="picChart" style="width: 100%;height:280px;"></div>
          </div>
          <div class="permissionData-right">
            <div ref="barChart" style="width: 100%;height:280px;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import echarts from 'echarts'

const color = {
  feishu: 'rgba(255,107,107, 1)',
  bing: 'rgba(72,170,255, 1)',
  google: 'rgba(255,220,38, 1)',
  baidu: 'rgba(223,154,255,1)'
  // other: 'rgba(100,247,114,1)',
  // share: 'rgba(255,176,112, 1)'
}
export default {
  props: {
    permissionData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      picData: [],
      picChart: null,
      barData: {},
      barChart: null,
      picOpts: {
        // backgroundColor: '#0a1a2a',
        tooltip: {
          trigger: 'item',
          backgroundColor: '#fff',
          borderWidth: 1,
          borderColor: '#dcdcdc',
          formatter: (params) => {
            return `
               <span style="color:#000">
                ${params.seriesName}
               </span>
                <br/>
                  ${params.marker}
                <span style="color:#000">
                  ${params.data['name']}
                  ：
                  ${params.percent.toFixed(1)}%
                </span>
              `
          }
        },
        series: [
          {
            name: this.permissionData.text,
            type: 'pie',
            radius: '60%',
            // center: ['45%', '48%'],
            color: [],
            minAngle: 5, //最小角度
            labelLine: {
              smooth: false,
              // length: 20,
              // length2: 70,
              lineStyle: {
                width: 1
                // color: '#dcdcdc',
              }
            },
            label: {
              formatter: (params) => {
                return `{a|${params.data['name']}}\n{b|${params.percent.toFixed(
                  1
                )}%}`
              },
              rich: {
                a: {
                  fontWeight: 500,
                  color: '#292929'
                },
                b: {
                  fontWeight: 400,
                  color: '#888888'
                }
              }
              // padding: [0, -65]
            },
            emphasis: {
              scaleSize: 10,
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.28)'
              }
            },
            data: []
          }
        ]
      },
      barOpts: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: []
        },
        grid: {
          top: '15%',
          bottom: '25%',
          left: '18%',
          right: '5%'
        },
        xAxis: [
          {
            type: 'category',
            axisTick: { show: false },
            axisLabel: { show: true, interval: 0, rotate: 45 },
            data: []
          }
        ],
        yAxis: [
          {
            type: 'value'
          }
        ],
        series: []
      }
    }
  },

  methods: {
    initPicChart() {
      this.picData = this.permissionData.engine.map((item) => {
        return {
          tag: item.tag,
          name: item.name,
          value: item.total
        }
      })
      this.picData = this.picData.filter((item) => item.tag !== 'all')
      this.initPic()
    },

    initPic() {
      this.picChart ? this.picChart.clear() : ''
      this.picChart = echarts.init(this.$refs.picChart)

      let colorArr = []
      for (let i of this.picData) {
        colorArr = [...colorArr, color[i.tag]]
      }
      this.picOpts.series[0].color = colorArr
      this.picOpts.series[0].data = this.picData
      this.picChart.setOption(this.picOpts)
    },

    changeTab(item) {
      this.barData = item
      this.initBarChart()
    },

    async initBarChart() {
      this.barChart ? this.barChart.clear() : ''
      this.barChart = echarts.init(this.$refs.barChart)
      this.barOpts.color = color[this.barData.tag]
      this.barOpts.xAxis[0].data = this.barData.date
      this.barOpts.series = await this.getSeriesData()
      if (this.barData.key === 'size') {
        this.barOpts.yAxis[0].name = '单位：MB'
        this.barOpts.tooltip.formatter = this.tooltip
      } else if (this.barData.key === 'count') {
        this.barOpts.yAxis[0].name = '单位：次'
      } else if (this.barData.key === 'word') {
        this.barOpts.yAxis[0].name = '单位：个（字数）'
      } else if (this.barData.key === 'second') {
        this.barOpts.yAxis[0].name = '单位：秒'
      }
      this.barChart.setOption(this.barOpts)
    },

    async getSeriesData() {
      try {
        let seriesData = []
        let tmpData = []
        if (this.barData.key === 'size') {
          tmpData = await this.renderSize(this.barData.data)
        } else {
          tmpData = this.barData.data
        }
        seriesData.push({
          name: this.barData.name,
          type: 'bar',
          barGap: 0,
          label: {
            show: false,
            rotate: 90,
            align: 'left',
            verticalAlign: 'middle',
            position: 'insideBottom',
            formatter: '{a} : {c}',
            fontSize: 14
            // rich: {
            //   name: {
            //     fontSize: 16,
            //     color: '#000'
            //   }
            // }
          },
          emphasis: {
            focus: 'series'
          },
          data: tmpData
        })

        return seriesData
      } catch (error) {}
    },

    tooltip(params) {
      let children = ''
      for (let item of params) {
        children += `<p>${item.seriesName}：${item.data}MB</p>`
      }
      let document = `
        <div>
          <p>${params[0].name}</p>
          ${children}
        </div>
      `
      return document
    },

    async renderSize(data) {
      try {
        let tmp = []
        for (let item of data) {
          tmp = [...tmp, (item / Math.pow(1024, 2)).toFixed(2)]
        }
        return tmp
      } catch (error) {}
    },

    chartResize() {
      this.picChart ? this.picChart.resize({ width: 'auto' }) : null
      this.barChart ? this.barChart.resize({ width: 'auto' }) : null
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.chartResize)
  },
  mounted() {
    if (this.permissionData.engine.length) {
      this.barData = this.permissionData.engine[0]
    }
    this.initPicChart()
    this.initBarChart()
    window.addEventListener('resize', this.chartResize)
  }
}
</script>

<style lang="scss">
.permissionData-container {
  flex: 1;
  display: flex;
  /* overflow: hidden; */
  > .permissionData-card {
    flex: 1;
    /* height: 420px; */
    display: flex;
    flex-direction: column;
    padding: 10px;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    /* overflow: hidden; */
    background: #fff;
    box-sizing: border-box;
    border-radius: 4px;
    .permissionData-barChart-header {
      margin-bottom: 12px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      .permissionData-date-select {
        background: #f9f9f9;
        border-radius: 4px;
        .permissionData-date-select-item {
          display: inline-block;
          padding: 3px 14px;
          /* margin-left: 10px; */
          font-size: 14px;
          border-radius: 4px;
          border: none;
          outline: none;
          cursor: pointer;
          -webkit-transition: all 0.3s;
          transition: all 0.3s;
          /* background: #ccc; */
          color: #7a7a7a;
        }
        .permissionData-date-select-active {
          background: #bf735b;
          color: #fff;
        }
      }
    }
    .permissionData-main {
      display: flex;
      flex: 1;
      flex-direction: column;
      /* align-items: center; */
      .permissionData-useInfo {
        display: flex;
        padding: 20px;
        box-sizing: border-box;
        background: #f9f9f9;
        border-radius: 10px;
        justify-content: space-between;
        /* .permissionData-useInfo-item + .permissionData-useInfo-item {
          margin-left: 50px;
        } */
        .permissionData-useInfo-item {
          /* display: flex;
        justify-content: space-between; */
          align-items: center;
          /* margin-bottom: 6px; */
          .permissionData-useInfo-item-name {
            font-size: 14px;
            color: #888888;
          }
          .permissionData-useInfo-item-value {
            font-size: 24px;
            color: #c90d0d;
          }
        }
      }
    }
  }
}
.permissionData-info {
  display: flex;
  align-items: center;
  /* overflow: hidden; */
  /* margin-top: 10px; */
  .permissionData-left,
  .permissionData-right {
    flex: 1;
  }
  .permissionData-left {
    /* border-right: 1px solid #dcdcdc; */
  }
  .permissionData-right {
    background: #f9f9f9;
    border-radius: 8px;
  }
}
</style>
